import { render, staticRenderFns } from "./Certification.vue?vue&type=template&id=fe76598e"
import script from "./Certification.vue?vue&type=script&lang=js"
export * from "./Certification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports